module.exports = __webpack_public_path__ + "img/aeroland-clinic-image-02.df1fd140.png";